<template>
	<div class="text top">
		<v-subheader>{{ label }}</v-subheader>
		<v-select
			v-bind:label="label"
			v-bind:items="items"
			v-on:change="selectChange($event)"
			single-line
			bottom
			>
		</v-select>
	</div>
</template>

<script>
function selectChange(value) {
	this.$emit('parent-value', value);
}

export default {
	props: {
		label: String,
		items: Array,
	},
	methods: {
		selectChange,
	},
};
</script>

<style lang="scss" scoped>
	.top {
		width: 100%;
	}
	.top .subheader{
		font-size: map-get($sizes, fourteen);
        font-weight: map-get($weights, w-six);
		height: 21px;;
		margin-bottom: 8px;
		padding: 0;
		width: 100%;
	}
	.input-group {
		flex-wrap: nowrap;
		padding: 0;
	}
	.input-group--select{
		background-color: white;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
		display: inline-flex;
		float: left;
		height: 40px;
		width: 100%;
	}
	.inputText {
		.input-group--text-field {
			background-color: white;
			box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);
			height: 40px;
		}
	}
</style>




// WEBPACK FOOTER //
// SelectButton.vue?02f7e70b